import {useMemo} from 'react';

import {useTranslation} from 'react-i18next';

import {ScreeningTotalCountPerStatus} from '../types/screeningExternalApplicantsTypes';

import {BaseStatCard} from '../../../../components/BaseStatCard/BaseStatCard';
import {StatsGridContainer} from '../../../../components/StatsGridContainer/StatsGridContainer';
import {greenColors} from '../../../../layouts/theme/designSystem';

interface Props {
  counts?: ScreeningTotalCountPerStatus;
}

const activeScreeningApplicantCount = (counts: ScreeningTotalCountPerStatus): number =>
  (counts.created ?? 0) + (counts.started ?? 0) + (counts.completed ?? 0);

export const ScreeningStatusCountDisplay = ({counts}: Props) => {
  const {t} = useTranslation();

  const total = useMemo(() => {
    if (!counts) {
      return '-';
    }
    return activeScreeningApplicantCount(counts);
  }, [counts]);

  const statusCards = [
    {
      key: 'total',
      label: t('screeningModule.statusCards.total'),
      value: total,
      valueSx: {color: greenColors[700], fontWeight: 700},
    },
    {
      key: 'pending',
      label: t('screeningModule.statusCards.pending'),
      value: counts?.created ?? '-',
      valueSx: {color: greenColors[500], fontWeight: 600},
    },
    {
      key: 'started',
      label: t('screeningModule.tabFilters.assessmentStarted'),
      value: counts?.started ?? '-',
      valueSx: {color: greenColors[500], fontWeight: 600},
    },
    {
      key: 'completed',
      label: t('screeningModule.tabFilters.completed'),
      value: counts?.completed ?? '-',
      valueSx: {color: greenColors[600], fontWeight: 600},
    },
    {
      key: 'deleted',
      label: t('screeningModule.tabFilters.deleted'),
      value: counts?.deleted ?? '-',
      valueSx: {color: greenColors[100], fontWeight: 600},
    },
  ];

  return (
    <StatsGridContainer>
      {statusCards.map((card) => (
        <BaseStatCard key={card.key} fillWidth title={card.label} value={card.value} valueSx={card.valueSx} />
      ))}
    </StatsGridContainer>
  );
};

export {activeScreeningApplicantCount};

